import { Col, Collapse, Flex, Row, Space, Tooltip } from 'antd'
import React from 'react'
import { CustomParagraph } from '../../components'
import { appHelper } from '../../common/helper';
 const { capitalize } =  appHelper();

const ShipmentMultipleProductDetail = ({products}) => {
  const { Panel } = Collapse;

  return (
    <>
              <Space direction="vertical" style={{ width: '100%' }}>
      <Collapse
        defaultActiveKey={['']}
        accordion
        expandIconPosition="right"
        style={{  borderRadius: '8px', border:'0'  }}
      >
        {products?.map((data, index) => (
          <Panel
            key={index}
            header={
              <div style={{ fontWeight: '600', fontSize: '12px', color: '#333' }}>
                {data.name} - {data.product_type}
              </div>
            }
            style={{
              marginBottom: '8px',
              background: '#fff',
              border: '1px solid #ddd',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
            }}
          >
            <Flex vertical={true} gap={12} > 
           <Row gap={24} justify="space-between">
            {/* product name  */}
            <Col span={11}>
              <CustomParagraph
                text={"Product"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />
              <CustomParagraph
              noText='--'
                text={data?.name}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
            {/* Quantity  */}
            <Col span={11}>
              <Tooltip
                title={"Total number of all products"}
                overlayStyle={{ maxWidth: "154px", textAlign: "center" }}
                placement="top"
              >
                <CustomParagraph
                  text={"Product quantity"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={data?.quantity}
                  noText='--'
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Tooltip>
            </Col>
          </Row>

          <Row gap={24} justify="space-between">
            {/* product type  */}
            <Col span={11}>
              <CustomParagraph
                text={"Product type"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />
              <CustomParagraph
                text={ capitalize(data?.product_type)}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            {/* project ID  */}
            <Col span={11}>
              <Tooltip
                title={data?.project_id || '--'}
                placement="top"
              >
                <span>
                <CustomParagraph
                  text={"Project ID"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />
                  <CustomParagraph
                    text={data?.project_id }
                    noText='--'
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="0"
                  />
                </span>
              </Tooltip>
            </Col>

          </Row>
          <Row gap={24} justify="space-between">
            {/* Temperature range */}
            <Col span={11}>
              <Tooltip
                title={"Temperature range overlap for all products"}
                overlayStyle={{ maxWidth: "154px", textAlign: "center" }}
                placement="top"
              >
                <CustomParagraph
                  text={"Temperature range"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={data?.temperature_range}
                  noText='--'
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Tooltip>
            </Col>
            {/* Transit Vibility window  */}
            <Col span={11}>
              <Tooltip
                title={"Minimum viability window for all product types"}
                overlayStyle={{ maxWidth: "154px", textAlign: "center" }}
                placement="top"
              >
                <CustomParagraph
                  text={"Transit viability window"}
                  fontSize={12}
                  fontWeight={600}
                  lineHeight="16px"
                  color="#000"
                  marginBottom="4px"
                />

                <CustomParagraph
                  text={data?.viability_window + " hrs"}
                  noText='--'
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="16px"
                  color="#4B4B4B"
                  marginBottom="0"
                />
              </Tooltip>
            </Col>
          </Row>
          {/* sensors  */}
          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Sensor"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={data?.sensor?.type ? data?.sensor?.type : "--"}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Sensor ID"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={data?.sensor?.id ? data?.sensor?.id : "--"}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>
          </Flex>
          </Panel>
        ))}
      </Collapse>
    </Space>
    </>
  )
}

export default ShipmentMultipleProductDetail